<template>
  <div>
    <!-- <geo-chart  height="500px" width="500px" :library="{region: 'ZA', resolution: 'provinces'}"  :data="data"></geo-chart> -->
    <v-layout justify-center mt-3 wrap>
      <v-flex xs2 mx-3 v-if="activeAccounts">
        <v-card
          min-width="120px"
          hover
          color="light-green"
          height="80px"
          class="rounded-card"
          @click="navigateServiceAccounts()"
        >
          <v-card-text>
            <v-layout wrap class="white--text" justify-center align-center>
              <v-flex xs12>
                <h3 class="title">Active Accounts</h3>
              </v-flex>
              <v-flex xs12>
                <h2>{{ activeAccounts.count }}</h2>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex xs2 mx-3 v-if="pendingApplications">
        <v-card
          min-width="120px"
          hover
          color="blue"
          height="80px"
          class="rounded-card"
          @click="navigateApplications()"
        >
          <v-card-text>
            <v-layout wrap class="white--text" justify-center align-center>
              <v-flex xs12>
                <h3 class="title">New Applications</h3>
              </v-flex>
              <v-flex xs12>
                <h2>{{ pendingApplications.count }}</h2>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex xs2 mx-3 v-if="networkOperatorCount">
        <v-card
          min-width="120px"
          hover
          color="purple"
          height="80px"
          class="rounded-card"
          @click="navigateNetworkOperators()"
        >
          <v-card-text>
            <v-layout wrap class="white--text" justify-center align-center>
              <v-flex xs12>
                <h3 class="title">Network Operators</h3>
              </v-flex>
              <v-flex xs12>
                <h2>{{ networkOperatorCount }}</h2>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex xs2 mx-3 v-if="changeRequest">
        <v-card
          min-width="120px"
          hover
          color="orange"
          height="80px"
          class="rounded-card"
          @click="navigateIsp()"
        >
          <v-card-text>
            <v-layout wrap class="white--text" justify-center align-center>
              <v-flex xs12>
                <h3 class="title">ISP's</h3>
              </v-flex>
              <v-flex xs12>
                <h2 class="font-weight-bold">{{ ispCount }}</h2>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout mt-2 wrap justify-center align-center>
      <v-flex xs6 sm3 md3 v-if="packageData.length > 0">
        <doughnutchart
          v-if="loaded"
          :chartdata="ispPackagesChartData"
          :options="ispPackagesChartOptions"
        >
        </doughnutchart>
      </v-flex>
     
      <v-flex xs6 sm3 md3>
        <v-container text-lg-center pt-5 text-xs-left>
          <v-layout align-center justify-left text-xs-left>
            <v-card flat color="white" text-xs-left>
              <v-flex xs12 sm12 md12>
                <v-layout my-5 wrap>
                  <v-flex xs2 my-2><v-icon>language</v-icon></v-flex>
                  <v-flex xs8 my-2><h3>Networks:</h3></v-flex>
                  <v-flex xs2 my-2
                    ><v-chip class="white--text" color="blue">
                      {{ fnoNetworks.length }}</v-chip
                    ></v-flex
                  >

                  <v-flex xs2 my-2><v-icon>home</v-icon></v-flex>
                  <v-flex xs8 my-2><h3>Units Passed:</h3></v-flex>
                  <v-flex xs2 my-2
                    ><v-chip class="white--text" color="purple">
                      {{
                        fnoNetworks.reduce(
                          (a, b) => +a + +b.locationNetwork.numberOfUnits,
                          0
                        )
                      }}</v-chip
                    ></v-flex
                  >

                  <v-flex xs2 my-2><v-icon>share</v-icon></v-flex>
                  <v-flex xs8 my-2><h3>Units Connected:</h3></v-flex>
                  <v-flex xs2 my-2
                    ><v-chip class="white--text" color="orange">
                      {{
                        fnoNetworks.reduce(
                          (a, b) => +a + +b.locationNetwork.connectedUnits,
                          0
                        )
                      }}</v-chip
                    ></v-flex
                  >

                  <v-flex xs2 my-2><v-icon>devices_other</v-icon></v-flex>
                  <v-flex xs8 my-2><h3>Service Accounts:</h3></v-flex>
                  <v-flex xs2 my-2
                    ><v-chip class="white--text" color="light-green">
                      {{ activeAccounts.count }}</v-chip
                    ></v-flex
                  >
                </v-layout>
              </v-flex>
            </v-card>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
     <v-layout justify-center align-center v-if="(packageData.length > 0) && (ispChartData.labels) && (ispChartData.labels.length>9)">
       <v-flex xs12 sm12 md12 >
        <barchart
          v-if="loaded"
          :chartdata="ispChartData"
          :options="ispChartOptions"
        >
        </barchart>
      </v-flex>
     </v-layout>
    <v-layout justify-center align-center>
       <v-flex xs6 sm6 md6 v-if="(packageData.length > 0) && (ispChartData.labels) && (ispChartData.labels.length<10)">
        <barchart
          v-if="loaded"
          :chartdata="ispChartData"
          :options="ispChartOptions"
        >
        </barchart>
      </v-flex>
      <v-flex xs6 sm6 md6 v-if="packageData.length > 0">
        <barchart
          v-if="loaded"
          :chartdata="supplierChartData"
          :options="supplierChartOptions"
        >
        </barchart>
      </v-flex>
    </v-layout>
    <div></div>
  </div>
</template>
<script>
import Api from "../services/Api";
import BarChart from "./BarChart.vue";
import PieChart from "./PieChart.vue";
import LineChart from "./LineChart.vue";
import DoughnutChart from "./DoughnutChart.vue";

export default {
  components: {
    barchart: BarChart,
    piechart: PieChart,
    linechart: LineChart,
    doughnutchart: DoughnutChart,
  },
  data() {
    return {
      loaded: false,
      ispPackagesChartData: {},
      ispPackagesChartOptions: {},
      networkChartData: {},
      networkChartOptions: {},
      stackedData: {},
      stackedDataOptions: {},
      ispChartData: {},
      ispChartDataOptions: {},
      supplierChartData: {},
      supplierChartOptions: {},
      networkOperatorCount: 0,
      ispCount: 0,
      fnoNetworks: [],
      activeAccounts: [],
      changeRequest: [],
      packageData: [],
      pendingApplications: [],
      networkData: [],
      networkSpeeds: [],
      unitsPassed: {
        count: 0,
      },
      unitsConnected: {
        count: 0,
      },
      ispData: [],
      supplierData:[],
      downloadSpeeds:[],
      tempPackageData: []
    };
  },
  created() {
    this.initialize();
    this.loaded = false;
  },
  async mounted() {
    //this.loadCharts();
  },
  methods: {
    async initialize() {
      this.getNetworkOperatorCount();
      this.getIspCount();
      this.getFnoNetworks();
      await this.getActiveAccounts();
      //await this.getActiveChangeRequests();
      await this.getPendingApplications();
      // await this.getLocationCount();
      // await this.getConnectedLocationCount();
      await this.getServiceAccountBySpeed();
      this.loadKey += 1;
      this.load = false;
    },
    getFnoNetworks() {
      Api()
        .get("/virtualFnoPackageLocationNetwork")
        .then((response) => {
          this.fnoNetworks = response.data;
        });
    },
    getNetworkOperatorCount() {
      Api()
        .get("/virtualProviderNetworkOperator/count")
        .then((response) => {
          this.networkOperatorCount = response.data.count;
        });
    },
    getIspCount() {
      Api()
        .get("/virtualIsp")
        .then((response) => {
          this.ispCount = response.data.length;
        });
    },
    async getLocationCount() {
      await Api()
        .get("/locations/active/count")
        .then((response) => {
          this.unitsPassed = response.data;
        });
    },
    async getConnectedLocationCount() {
      await Api()
        .get("/locations/connected/count")
        .then((response) => {
          this.unitsConnected = response.data;
        });
    },
    async getActiveAccounts() {
      await Api()
        .get("/serviceAccounts/owner/allActive/count")
        .then((response) => {
          this.activeAccounts = response.data;
        });
    },
    async getServiceAccountBySpeed() {
      await Api()
        .get("/serviceAccounts/owner/allActive/speed")
        .then(async (response) => {
          let speedProfiles = [
            ...new Set(
              response.data.map(
                (item) => item.packagesIsp.packagesFno.speedProfileId
              )
            ),
          ];
          let ispArray = [
            ...new Set(
              response.data.map(
                (item) => item.packagesIsp.customerOrganisationId
              )
            ),
          ];
          let supplierArray = [
            ...new Set(
              response.data.map(
                (item) => item.packagesIsp.supplierOrganisationId
              )
            ),
          ];
          let networks = [
            ...new Set(
              response.data.map((item) => item.location.locationNetworkId)
            ),
          ];
          this.ispData = [];
          await ispArray.map((e) => {
            let isp = response.data.find(
              (x) => x.packagesIsp.customerOrganisation.id === e
            );
            this.ispData.push({
              id: e,
              customerOrganisation: isp.packagesIsp.customerOrganisation,
              count: response.data.filter(
                (f) => f.packagesIsp.customerOrganisationId === e
              ).length,
            });
          });
          this.ispData.sort((a, b) =>
            a.count < b.count ? 1 : b.count < a.count ? -1 : 0
          );

          this.supplierData = [];
          await supplierArray.map((e) => {
            let isp = response.data.find(
              (x) => x.packagesIsp.supplierOrganisation.id === e
            );
            this.supplierData.push({
              id: e,
              supplierOrganisation: isp.packagesIsp.supplierOrganisation,
              count: response.data.filter(
                (f) => f.packagesIsp.supplierOrganisationId === e
              ).length,
            });
          });
          this.supplierData.sort((a, b) =>
            a.count < b.count ? 1 : b.count < a.count ? -1 : 0
          );

          this.packageData = [];
          await speedProfiles.map((x) => {
            let find = response.data.find(
              (z) => z.packagesIsp.packagesFno.speedProfile.id === x
            );
            this.packageData.push({
              id: x,
              speedProfile: find.packagesIsp.packagesFno.speedProfile,
              colour: find.packagesIsp.packagesFno.speedProfile.colour,
              count: response.data.filter(
                (y) => y.packagesIsp.packagesFno.speedProfileId === x
              ).length,
            });
          });
          this.packageData.sort((a, b) =>
            a.speedProfile.downloadMbps > b.speedProfile.downloadMbps
              ? 1
              : b.speedProfile.downloadMbps > a.speedProfile.downloadMbps
              ? -1
              : 0
          );

          this.networkData = [];

          await networks.map((x) => {
            let find = response.data.find(
              (z) => z.location.locationNetwork.id === x
            );
            this.networkData.push({
              id: x,
              locationNetwork: find.location.locationNetwork,
              count: response.data.filter(
                (y) => y.location.locationNetworkId === x
              ).length,
            });
          });

          this.networkData.sort((a, b) =>
            a.count < b.count ? 1 : b.count < a.count ? -1 : 0
          );

          this.networkSpeeds = [];

          for (let a = 0; a < this.packageData.length; a++) {
            let color = await this.getRandomColors(1);
            let obj = {
              speedProfileId: this.packageData[a].speedProfile.id,
              label: this.packageData[a].speedProfile.name,
              colour: this.pSBC(0.35, this.packageData[a].speedProfile.colour),
              backgroundColor: color.background,
              borderColor: color.border,
              borderWidth: 1,
              data: [],
            };
            this.networkSpeeds.push(obj);
          }

          for (let b = 0; b < this.networkData.length; b++) {
            for (let c = 0; c < this.networkSpeeds.length; c++) {
              let count = await response.data.filter(
                (d) =>
                  d.location.locationNetworkId ===
                    this.networkData[b].locationNetwork.id &&
                  d.packagesIsp.packagesFno.speedProfileId ===
                    this.networkSpeeds[c].speedProfileId
              ).length;
              await this.networkSpeeds[c].data.push(count);
            }
          }
          this.loadCharts();
        });
    },
    async getPendingApplications() {
      await Api()
        .get("/applications/owner/pending/count")
        .then((response) => {
          this.pendingApplications = response.data;
        });
    },
    navigateApplications() {
      this.$router.push({ path: "/virtualOwnerApplications" });
    },
    navigateServiceAccounts() {
      this.$router.push({ path: "/virtualServiceAccounts" });
    },
    navigateNetworkOperators() {
      this.$router.push({ path: "/virtualFibreNetworkOperators" });
    },
    navigateIsp() {
      this.$router.push({ path: "/virtualIsp" });
    },
    async loadCharts() {
      this.downloadSpeeds = []
      this.tempPackageData = []

      await this.packageData.map(x => {
         if(this.downloadSpeeds.includes(x.speedProfile.downloadMbps)){
            let find = this.tempPackageData.find(
              z => z.speedProfile.downloadMbps === x.speedProfile.downloadMbps
            );
        let ind = this.tempPackageData.indexOf(find)
            this.tempPackageData[ind].count = this.tempPackageData[ind].count + x.count
         }else{
               this.downloadSpeeds.push(x.speedProfile.downloadMbps)
               this.tempPackageData.push(x)
         }

      })
      let colors = this.getRandomColors(this.tempPackageData.length)
      let networkSpeedColors = this.getRandomColors(this.packageData.length)


    this.ispPackagesChartData = {
        labels: this.tempPackageData.map(
          (x) => x.speedProfile.downloadMbps + "Mbps"
        ),
        datasets: [
          {
            label: "Speed",
            data: this.tempPackageData.map((x) => x.count),
            backgroundColor: this.tempPackageData.map((x) => this.pSBC(0.35, x.colour)),
            borderColor: this.tempPackageData.map((x) => x.colour),
            borderWidth: 1,
          },
        ],
      }
        this.ispPackagesChartOptions = {
          title: {
            display: true,
            text: "Packages Sold by Speed",
          },
          tooltip: {
            enabled: true,
          },
        }
      // Network Chart
      let networkColors = this.getRandomColors(this.networkData.length);
      (this.networkChartData = {
        labels: this.networkData.map((x) => x.locationNetwork.name),
        datasets: [
          {
            label: "Sold",
            data: this.networkData.map((x) => x.count),
            backgroundColor: networkColors.background,
            borderColor: networkColors.border,
            borderWidth: 1,
          },
        ],
      }),
        (this.networkChartOptions = {
          title: {
            display: true,
            text: "Packages Sold by Network",
          },
          tooltip: {
            enabled: true,
          },
        }),
        (this.ispChartData = {
          labels: this.ispData.map((x) => x.customerOrganisation.name),
          datasets: [
            {
              label: "Sold",
              data: this.ispData.map((x) => x.count),
              backgroundColor: this.pSBC(0.35, this.$vuetify.theme.primary),
              borderColor: this.$vuetify.theme.primary,
              borderWidth: 1,
            },
          ],
        }),        
        (this.ispChartOptions = {
          responsive: true,
          maintainAspectRatio: false,
          title: {
            display: true,
            text: "Packages Sold by ISP",
          },
          tooltip: {
            enabled: true,
          },
        }),
         (this.supplierChartData = {
          labels: this.supplierData.map((x) => x.supplierOrganisation.name),
          datasets: [
            {
              label: "Sold",
              data: this.supplierData.map((x) => x.count),
              backgroundColor: this.pSBC(0.35, this.$vuetify.theme.primary),
              borderColor: this.$vuetify.theme.primary,
              borderWidth: 1,
            },
          ],
        }),
        (this.supplierChartOptions = {
          responsive: true,
          maintainAspectRatio: false,
          title: {
            display: true,
            text: "Packages Sold by Supplier",
          },
          tooltip: {
            enabled: true,
          },
        }),
        await this.networkSpeeds.map((z) => {
          let index = this.networkSpeeds.indexOf(z);
          z.backgroundColor = this.pSBC(0.35, networkSpeedColors.background[index]);
          z.borderColor = networkSpeedColors.border[index];
        });
      (this.stackedData = {
        labels: this.networkData.map((x) => x.locationNetwork.name),
        datasets: this.networkSpeeds,
      }),
        (this.stackedDataOptions = {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            xAxes: [
              {
                stacked: true,
                categoryPercentage: 0.8,
                barPercentage: 1,
              },
            ],
            yAxes: [
              {
                stacked: true,
              },
            ],
          },
        });

      this.loaded = true;
    },
    getRandomColors(number) {
      var letters = "0123456789ABCDEF";
      var color = "#";
      let array = { background: [], border: [] };
      for (let x = 0; x < number; x++) {
        for (var i = 0; i < 6; i++) {
          color += letters[Math.floor(Math.random() * 16)];
        }
        array.border.push(color);
        array.background.push(this.pSBC(0.35, color));
        color = "#";
      }
      return array;
    },
    pSBC(p, c0, c1, l) {
      let r,
        g,
        b,
        P,
        f,
        t,
        h,
        i = parseInt,
        m = Math.round,
        a = typeof c1 == "string";
      if (
        typeof p != "number" ||
        p < -1 ||
        p > 1 ||
        typeof c0 != "string" ||
        (c0[0] != "r" && c0[0] != "#") ||
        (c1 && !a)
      )
        return null;
      if (!this.pSBCr)
        this.pSBCr = (d) => {
          let n = d.length,
            x = {};
          if (n > 9) {
            ([r, g, b, a] = d = d.split(",")), (n = d.length);
            if (n < 3 || n > 4) return null;
            (x.r = i(r[3] == "a" ? r.slice(5) : r.slice(4))),
              (x.g = i(g)),
              (x.b = i(b)),
              (x.a = a ? parseFloat(a) : -1);
          } else {
            if (n == 8 || n == 6 || n < 4) return null;
            if (n < 6)
              d =
                "#" +
                d[1] +
                d[1] +
                d[2] +
                d[2] +
                d[3] +
                d[3] +
                (n > 4 ? d[4] + d[4] : "");
            d = i(d.slice(1), 16);
            if (n == 9 || n == 5)
              (x.r = (d >> 24) & 255),
                (x.g = (d >> 16) & 255),
                (x.b = (d >> 8) & 255),
                (x.a = m((d & 255) / 0.255) / 1000);
            else
              (x.r = d >> 16),
                (x.g = (d >> 8) & 255),
                (x.b = d & 255),
                (x.a = -1);
          }
          return x;
        };
      (h = c0.length > 9),
        (h = a ? (c1.length > 9 ? true : c1 == "c" ? !h : false) : h),
        (f = this.pSBCr(c0)),
        (P = p < 0),
        (t =
          c1 && c1 != "c"
            ? this.pSBCr(c1)
            : P
            ? { r: 0, g: 0, b: 0, a: -1 }
            : { r: 255, g: 255, b: 255, a: -1 }),
        (p = P ? p * -1 : p),
        (P = 1 - p);
      if (!f || !t) return null;
      if (l)
        (r = m(P * f.r + p * t.r)),
          (g = m(P * f.g + p * t.g)),
          (b = m(P * f.b + p * t.b));
      else
        (r = m((P * f.r ** 2 + p * t.r ** 2) ** 0.5)),
          (g = m((P * f.g ** 2 + p * t.g ** 2) ** 0.5)),
          (b = m((P * f.b ** 2 + p * t.b ** 2) ** 0.5));
      (a = f.a),
        (t = t.a),
        (f = a >= 0 || t >= 0),
        (a = f ? (a < 0 ? t : t < 0 ? a : a * P + t * p) : 0);
      if (h)
        return (
          "rgb" +
          (f ? "a(" : "(") +
          r +
          "," +
          g +
          "," +
          b +
          (f ? "," + m(a * 1000) / 1000 : "") +
          ")"
        );
      else
        return (
          "#" +
          (
            4294967296 +
            r * 16777216 +
            g * 65536 +
            b * 256 +
            (f ? m(a * 255) : 0)
          )
            .toString(16)
            .slice(1, f ? undefined : -2)
        );
    },
  },
};
</script>